import { currency } from './currency.util';

const brazil = {
  validCpf: (pattern: string) => {
    return /(\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2})|(\d{3}\.\d{3}\.\d{3}-\d{2})/.test(pattern);
  },
  cpfInputMask: (unformattedCpfNumber: string): string => {
    if (!/\d{11}/.test(unformattedCpfNumber)) {
      unformattedCpfNumber = unformattedCpfNumber.substring(0, 11);
    }
    const baseDigits = unformattedCpfNumber.substring(0, 9);
    const calculatedResult = unformattedCpfNumber.substring(9, 11);

    return `${currency.format(baseDigits, { allowLeadingZeros: true })}-${calculatedResult}`;
  },
  cnpjInputMask: (unformattedCnpjNumber: string): string => {
    if (!/\d{14}/.test(unformattedCnpjNumber)) {
      unformattedCnpjNumber = unformattedCnpjNumber.substring(0, 14);
    }
    const bodyIssuingNumber = unformattedCnpjNumber.substring(0, 8);
    const companyBranch = unformattedCnpjNumber.substring(8, 12);
    const calculatedResult = unformattedCnpjNumber.substring(12);

    return `${currency.format(bodyIssuingNumber, { allowLeadingZeros: true })}/${companyBranch}-${calculatedResult}`;
  },
  cleanCpfCnpjValue: (value: string): string => {
    const unformattedValue = value.replace(/[^0-9]/g, '');
    return unformattedValue;
  }
};

export { brazil };
